module.exports = __webpack_public_path__ + "img/cross-media.dcf2ae76.png";